/**
 * Centralized University & Institutional Branding Configuration
 */

export interface UniversityConfig {
  name: string;
  shortName: string;
  website: string;
  address: string;
  logoPath: string;
  logoFullUrl?: string;
  branding: {
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
  };
  departments: string[];
  defaultDepartment: string;
}

export const UNIVERSITY_CONFIG: UniversityConfig = {
  name: 'East West University',
  shortName: 'EWU',
  website: 'https://www.ewubd.edu/',
  address: 'A/2, Jahurul Islam Avenue\nJahurul Islam City, Aftabnagar\nDhaka-1212, Bangladesh',
  logoPath: '/assets/branding/ewu_logo_small.png',
  logoFullUrl: 'https://www.ewubd.edu/themes/east-west-university/assets/default/images/logo.png',
  
  branding: {
    primaryColor: '#22326b',
    secondaryColor: '#22326b',
    accentColor: '#1d4ed8',
  },
  
  departments: [
    'Computer Science and Engineering',
    'Civil Engineering',
    'Economics',
    'Social Relations',
    'English',
    'Electrical and Electronic Engineering',
    'Pharmacy',
    'Business Administration',
    'Law',
    'Genetic Engineering and Biotechnology',
    'Information Studies',
    'Other',
  ],

  defaultDepartment: 'Computer Science and Engineering',
};
